import forGotImg from '../assets/image3.png';
import logoImg from '../logo.svg';
import './Login.css';
import React, { useState } from 'react';
import axios from 'axios';
import { ForgetPassword } from '../apiconfig/authService';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await ForgetPassword({ email });
            if (response.status === 200) {
                setMessage(response.data.message);
            }
        } catch (err) {
            if ((err.response && err.response.data) && err.response.data.error) {
                setMessage(err.response.data.error);
            } else {
                setMessage('An error occurred. Please try again later.');
            }
        }
    };


    return (
        <div className="LoginPage container-fluid">
            <div className="row bg-light">
                <div className="col-lg-8 p-5">
                    <img src={forGotImg} className="loginImg d-block mx-auto img-fluid" width="700" alt=" Dummy" />
                </div>
                <div className="col-lg-4 bg-white p-5 d-flex align-items-center">
                    <div className="loginCont w-100">
                        <div className="logo mb-4">
                            <img src={logoImg} className="logoImg img-fluid" width="80" alt="Logo" />
                        </div>
                        <h3 className="text-primary mb-4">Forgot Password?</h3>
                        <p>Enter your email and we′ll send you instructions to reset your password</p>

                        {message && <div className="alert alert-primary" role="alert">{message}</div>}
                        <form onSubmit={handleSubmit} className="LoginForm">
                            <div className="form-floating mb-4">
                                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" id="floatingInput" placeholder="name@example.com" />
                                <label htmlFor="floatingInput">Email address</label>
                            </div>
                            <div className="buttons mb-4">
                                <button type="submit" className="btn btn-primary shadow-sm btn-lg w-100 text-uppercase">Send Reset Link</button>
                            </div>
                            <div className="regis mb-4 text-center">
                                {/*<link to="/register" className="fw-bold text-primary">Back to Login</link> */}
                                <a href="/" className="fw-bold text-primary text-decoration-none">Back to Sign In</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ForgotPassword;